import React, { useEffect } from 'react';
import { Route, withRouter, useLocation } from 'react-router-dom';
import App from "./App";
import Login from "./pages/general/Login";
import Error from "./pages/general/Error";
import NotFound from "./pages/general/NotFound";
import Access from "./pages/general/Access";

const AppWrapper = (props) => {
	let location = useLocation();

	useEffect(() => {
		document.body.style.overflow = 'hidden'
		//window.scrollTo(0, 0)
	}, [location]);

	switch (props.location.pathname) {
		case "/login":
			return <Route path="/login" component={Login} />
		case "/error":
			return <Route path="/error" component={Error} />
		case "/notfound":
			return <Route path="/notfound" component={NotFound} />
		case "/access":
			return <Route path="/access" component={Access} />
		default:
			return <App />;
	}

}

export default withRouter(AppWrapper);
